/**
 * Helpers for the written articles on reaction and element pages.
 */

// The fixed order and headings of a reaction article. `history` is optional.
export const REACTION_ARTICLE_PARTS = Object.freeze([
  { key: 'see', heading: "What you'd see" },
  { key: 'why', heading: 'Why it happens' },
  { key: 'realLife', heading: 'Where you meet it in real life' },
  { key: 'history', heading: 'A bit of history' },
  { key: 'tryAtHome', heading: 'Try this safely at home' },
]);

export function countWords(text) {
  return text.split(/\s+/).filter((word) => /[a-z0-9]/i.test(word)).length;
}

/**
 * Turns a reaction article's parts into [{ heading, paragraphs }], skipping parts it doesn't have.
 */
export function buildReactionArticleSections(article) {
  return REACTION_ARTICLE_PARTS.filter(({ key }) => article[key]?.length).map(({ key, heading }) => ({
    heading,
    paragraphs: article[key],
  }));
}

/**
 * All the words a reader sees in an article: intro, section headings and paragraphs, and the quiz.
 */
export function countArticleWords({ intro = '', sections = [], quiz = [] }) {
  const texts = [
    intro,
    ...sections.flatMap(({ heading, paragraphs }) => [heading, ...paragraphs]),
    ...quiz.flatMap(({ question, answer }) => [question, answer]),
  ];
  return texts.reduce((total, text) => total + countWords(text), 0);
}
